import { DELETE_METHOD, GET_METHOD, POST_METHOD, PUT_METHOD } from "../../axiosMethod";
import { getHeaders } from "../../config";

export const createAssesment = async (payload) => {
  try {
    const data = await POST_METHOD(`assessment/create/${payload?.locationId}`, {}, {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};

export const getAssesmentProgress = async (assesmentId, isSolelyManaged) => {
  try {
    const data = await GET_METHOD(`assessment/location/${assesmentId}?isSolelyManaged=${isSolelyManaged || false}`, {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};

export const getAssesmentQuestions = async (assesmentId) => {
  try {
    const data = await GET_METHOD(`questionnaire/${assesmentId}`, {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};

export const saveResponse = async (assesmentId, payload) => {
  try {
    const data = await POST_METHOD(`assessment/${assesmentId}/responses`, payload, {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};

export const updateStatus = async (assesmentId, payload) => {
  try {
    const data = await PUT_METHOD(`assessment/${assesmentId}/status`, payload, {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};

export const updateSubmitStatus = async (assesmentId, payload) => {
  try {
    const data = await PUT_METHOD(`/assessment/${assesmentId}/submit-page-trigger`, payload, {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};

export const uploadImageApi = async (payload, locationId, assessmentId) => {
  try {
    const formData = new FormData();
    formData.append("file", payload.file);
    formData.append("ref", payload.ref);

    const data = await POST_METHOD(`file/upload/${locationId}/${assessmentId}`, formData, {
      headers: {
        ...getHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });

    return data?.data
  } catch (error) {
    console.log("Error uploading image: ", error?.response?.data);
    throw error;
  }
};

export const removeImage = async (fileId) => {

  try {
    const { data } = DELETE_METHOD(`file/${fileId}`, { headers: getHeaders() });
    return data;
  } catch (error) {
    console.log("Error fetching user responses: ", error?.response?.data || error.message);
  }
}
